import Vue from "vue";
import vDragDrop from "v-drag-drop";

Vue.use(vDragDrop);